import styled, { css } from 'styled-components';
import { getAppearance, getProminence, LinkButton } from '../../components';
import { colorCSS, fontSizes, h4, radius, shadow } from '../../styles';
export const Section = styled.section `
  display: grid;
  gap: 1.5rem;

  ${({ disableLegacyAppearance }) => !disableLegacyAppearance &&
    `
    background-color: ${colorCSS('N0')};
    border-radius: ${radius.button};
    box-shadow: ${shadow.normal};
    margin: 0 auto;
    max-width: 400px;
    padding: 2rem;
  `}

  form {
    display: grid;
    gap: 1.5rem;
  }

  .text {
    text-align: center;
    &.text-tos {
      text-align: left;
    }
    &.text-footer {
      margin-top: 0.5rem;
    }
    &.text-incompatible {
      background-color: ${colorCSS('R300')};
      margin: -2rem -2rem 0;
      padding: 1rem 2rem;
      a {
        color: ${colorCSS('R50')};
        &:hover {
          color: ${colorCSS('N0')};
        }
      }
      p {
        color: ${colorCSS('N0')};
      }
    }
  }

  p {
    color: ${colorCSS('N300')};
    font-size: ${fontSizes.xs};
    margin: 0;
    & + p {
      margin-top: 1rem;
    }
  }
`;
const formInputCSS = `
  font-size: ${fontSizes.sm};
  padding: 0.5rem;
  width: 100%;
`;
export const InputEmail = styled.input `
  ${formInputCSS}
  background-color: ${colorCSS('N10')};
  border: 2px solid ${colorCSS('N40')};
  border-radius: ${radius.button};
  ::placeholder {
    color: ${colorCSS('N80')};
    opacity: 1;
  }
`;
export const SubmitButton = styled.button `
  ${({ disableLegacyAppearance }) => disableLegacyAppearance
    ? css `
          justify-content: center;
          ${getAppearance('Primary')}
          ${getProminence()}
        `
    : `
    ${formInputCSS}
    background-color: ${colorCSS('G300')};
    border: 0;
    color: ${colorCSS('N0')};
    font-weight: 500;
    &:hover {
      background-color: ${colorCSS('G200')};
    }
  `}
  &[disabled] {
    background-color: ${colorCSS('N30')} !important;
    border: 0;
    color: ${colorCSS('N100')} !important;
    cursor: not-allowed;
  }
`;
export const Heading = styled.h1 `
  ${h4}
  margin: 0;
`;
export const SocialButtons = styled.div `
  display: grid;
  ${({ disableLegacyAppearance }) => disableLegacyAppearance
    ? css `
          gap: 0.5rem;
          grid-template-columns: 1fr 1fr;
        `
    : css `
          gap: 1rem;
        `}
`;
// TODO LinkButton isBlock={true} should do this, but currently it does not
export const BlockLinkButton = styled(LinkButton) `
  display: block !important;
`;
//# sourceMappingURL=UiLoginSignupForm.styles.js.map